import React from 'react';
import PropTypes from 'prop-types';

import './LoadingAnimation.scss';

/**
 * | What         | Description                                               |
 * |--------------|-----------------------------------------------------------|
 * | **Purpose:** | Simple loading animation
 * | **Usage:**   | Any kind of context
 * | **Info:**    | A simple loading animation.
 *
 * @author [Denis Danielyan](mailto:denis.danielyan-extern@invia.de)
 */

export default function LoadingAnimation(props) {
  return <div className="loader">{props.placeholder !== undefined ? props.placeholder : 'Loading...'}</div>;
}

LoadingAnimation.propTypes = {
  /** Placeholder text*/
  placeholder: PropTypes.string
};
